// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

// Components
import call from './call';
import email from './email';
import monitoringalert from './monitoring-alert';

const components = { call, email, monitoringalert };

class TriageItem extends React.PureComponent {
  static propTypes = {
    item: PropTypes.object,
    currentUser: PropTypes.object
  }

  constructor() {
    super();

    this.state = { open: false };
    this.setOpen = this.setOpen.bind(this);
  }

  setOpen(open) {
    this.setState({ open });
  }

  render() {
    const { item, ...passed } = this.props;
    const { open } = this.state;
    const Component = components[item.type];
    const triageItem = _.defaults({ open, setOpen: this.setOpen }, item);
  
    return <Component {...passed} item={triageItem} />;
  }
}

export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(TriageItem);



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/index.js